import { useEffect, useState } from "react";
import { ArrowRight, Download, Receipt } from "lucide-react";
import { PageHeader, StatCard, StatusPill } from "../components/Primitives";
import { api, errorText, inr, formatDate } from "../lib/api";

export default function Invoices() {
  const [invoices, setInvoices] = useState([]);
  const [error, setError] = useState("");

  const load = async () => {
    try {
      const res = await api.get("/invoices");
      setInvoices(res.data.data);
    } catch (err) {
      setError(errorText(err));
    }
  };

  useEffect(() => {
    load();
  }, []);

  const totals = invoices.reduce(
    (acc, invoice) => {
      acc[invoice.status] = (acc[invoice.status] || 0) + Number(invoice.final_amount || 0);
      return acc;
    },
    { PAID: 0, PENDING: 0, OVERDUE: 0 }
  );

  const markPaid = async (invoice) => {
    try {
      await api.post(`/libraries/${invoice.library_id}/invoices/${invoice.id}/mark-paid`);
      load();
    } catch (err) {
      setError(errorText(err));
    }
  };

  return (
    <div className="page-enter">
      <PageHeader eyebrow="PLATFORM BILLING" title="Invoices" description="Every library subscription invoice in one ledger." />
      {error ? <div className="error-message">{error}</div> : null}
      <div className="stat-grid">
        <StatCard label="Paid" value={inr(totals.PAID)} detail={`${invoices.filter((item) => item.status === "PAID").length} invoices`} tone="green" icon={<Receipt size={18} />} />
        <StatCard label="Pending" value={inr(totals.PENDING)} detail={`${invoices.filter((item) => item.status === "PENDING").length} invoices`} tone="orange" icon={<Receipt size={18} />} />
        <StatCard label="Overdue" value={inr(totals.OVERDUE)} detail="Follow-up" tone="dark" icon={<Receipt size={18} />} />
        <StatCard label="Total" value={invoices.length} detail="All invoices" icon={<Receipt size={18} />} />
      </div>

      <section className="content-card table-card">
        <div className="table-toolbar">
          <div>
            <span className="card-kicker">LEDGER</span>
            <h2>{invoices.length} invoices</h2>
          </div>
        </div>
        <div className="table-wrap">
          <table data-testid="invoices-table">
            <thead>
              <tr><th>Invoice</th><th>Library</th><th>Plan</th><th>Amount</th><th>Billing</th><th>Due</th><th>Status</th><th>Action</th></tr>
            </thead>
            <tbody>
              {invoices.map((invoice) => (
                <tr key={invoice.id} data-testid={`invoice-row-${invoice.id}`}>
                  <td><strong>{invoice.invoice_number}</strong></td>
                  <td>{invoice.library_name}</td>
                  <td>{invoice.plan_name}</td>
                  <td>{inr(invoice.final_amount)}</td>
                  <td>{formatDate(invoice.billing_date)}</td>
                  <td>{formatDate(invoice.due_date)}</td>
                  <td><StatusPill status={invoice.status} /></td>
                  <td>
                    {invoice.status !== "PAID" ? (
                      <button className="button button-outline button-small" onClick={() => markPaid(invoice)} data-testid={`mark-paid-${invoice.id}`}>Mark paid</button>
                    ) : (
                      <span style={{ fontSize: 11, color: "#16a34a" }}>✓ Paid</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
